<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.0998 13.4029C15.1998 13.4029 17.7998 10.9029 17.7998 7.7029C17.7998 4.6029 15.2998 2.0029 
    12.0998 2.0029C8.8998 1.9029 6.2998 4.4029 6.2998 7.6029C6.2998 10.8029 8.8998 13.4029 12.0998 13.4029Z"
    fill="#748097"
  />
  <path
    d="M21.5 27.356L15 20.9028C14.5566 20.4595 13.6699 20.4595 13.2266 20.9028C12.7832 21.3462 12.7832 
    22.2329 13.2266 22.6763L21.5 30.9028L31 17.9027C31.4434 17.4593 31.4434 16.6834 31 16.2401C30.4458 
    15.6859 29.67 15.7967 29.2266 16.3509L21.5 27.356Z"
    fill="#009DD6"
  />
  <path
    d="M21.5 27.356L21.1478 27.7108L21.5685 28.1286L21.9092 27.6433L21.5 27.356ZM15 20.9028L14.6464 
    21.2564L14.6477 21.2577L15 20.9028ZM13.2266 22.6763L12.873 23.0298L12.874 23.0308L13.2266 22.6763ZM21.5 
    30.9028L21.1475 31.2574L21.5603 31.6678L21.9037 31.1978L21.5 30.9028ZM31 17.9027L30.6465 17.5491L30.6191 
    17.5765L30.5963 17.6077L31 17.9027ZM29.2266 16.3509L28.8362 16.0386L28.8264 16.0508L28.8174 16.0636L29.2266 
    16.3509ZM21.8523 27.0012L15.3523 20.548L14.6477 21.2577L21.1478 27.7108L21.8523 27.0012ZM15.3536 20.5493C15.0169
    20.2126 14.545 20.0703 14.1133 20.0703C13.6815 20.0703 13.2097 20.2126 12.873 20.5493L13.5801 21.2564C13.6868 
    21.1497 13.88 21.0703 14.1133 21.0703C14.3466 21.0703 14.5398 21.1497 14.6464 21.2564L15.3536 20.5493ZM12.873 
    20.5493C12.5364 20.8859 12.3941 21.3578 12.3941 21.7895C12.3941 22.2213 12.5364 22.6931 12.873 23.0298L13.5801 
    22.3227C13.4734 22.216 13.3941 22.0228 13.3941 21.7895C13.3941 21.5563 13.4734 21.3631 13.5801 21.2564L12.873 
    20.5493ZM12.874 23.0308L21.1475 31.2574L21.8526 30.5483L13.5791 22.3217L12.874 23.0308ZM21.9037 31.1978L31.4037 
    18.1977L30.5963 17.6077L21.0963 30.6078L21.9037 31.1978ZM31.3536 18.2562C31.9922 17.6176 31.9922 16.5252 31.3536 
    15.8865L30.6465 16.5936C30.8946 16.8417 30.8946 17.301 30.6465 17.5491L31.3536 18.2562ZM31.3536 15.8865C30.5668 
    15.0997 29.4458 15.2765 28.8362 16.0386L29.617 16.6633C29.8941 16.3169 30.3249 16.2721 30.6465 16.5936L31.3536 
    15.8865ZM28.8174 16.0636L21.0908 27.0687L21.9092 27.6433L29.6358 16.6382L28.8174 16.0636Z"
    fill="#009DD6"
  />
  <path
    d="M11 24.7028C9.4 23.1028 9.4 20.5028 11 18.9028C11.8 18.1028 12.8 17.7028 13.9 17.7028C15 17.7028 16 18.1028 
    16.8 18.9028L18.5 20.6028L21.2 17.6028C20 16.4028 18.3 15.6028 16.5 15.6028H7.7C4 15.6028 1 18.5028 1 22.3028V24.9028C1 
    25.5028 1.4 25.9028 2 25.9028H12.2L11 24.7028Z"
    fill="#748097"
  />
</svg>
